<div class="warning-banner neptune-margin" *ngIf="!isDismissed">
  <div class="warning-content">
    <img class="warning-icon" src="assets/warning-icon.svg" alt="warning-icon" />
    <!-- <span><b>Important Notice: </b>This page is set to be removed November 2024, please use the Service Insights tab and Excel Download for this data.</span> -->
    <span><b>Important Notice: </b>{{ message || defaultMessage }}</span> <!-- Use optional chaining to show default message -->
  </div>
  <ng-container *ngIf="showCloseButton">
    <button class="close-button" (click)="dismissBanner()" aria-label="Close banner">
      ✕
    </button>
  </ng-container>
</div>
